import { FormWrapper } from '../../../../../theme/default/base'

export const BlogBodyForm = () => {
  return <FormWrapper></FormWrapper>
}
